// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YTHi","controls":"styles_controls__d3jCe","charLimit":"styles_charLimit__32x3B","input":"styles_input__1nrd1","send":"styles_send__2UdLq"};